import * as types from './mutations-type'

export const setMuid = ({commit}, payload) => {
    commit(types.MUID, payload)
}

export const setStatus = ({commit}, payload) => {
    commit(types.STATUS, payload)
}

export const setSubject = ({commit}, payload) => {
    commit(types.SUBJECT, payload)
}
export const setFirstname = ({commit}, payload) => {
    commit(types.FIRSTNAME, payload)
}
export const setLastname = ({commit}, payload) => {
    commit(types.LASTNAME, payload)
}

export const setState = ({commit}, payload) => {
    commit(types.STATE, payload)
}
export const setAge = ({commit}, payload) => {
    commit(types.AGE, payload)
}
export const setPanelistemail = ({commit}, payload) => {
    commit(types.PANELISTEMAIL, payload)
}


export const setSender = ({commit}, payload) => {
    commit(types.SENDER, payload)
}

export const setPoints = ({commit}, payload) => {
    commit(types.POINTS, payload)
}

export const setDate = ({commit}, payload) => {
    commit(types.DATE, payload)
}

export const setForwardTo = ({commit}, payload) => {
    commit(types.FORWARDTO, payload)
}

export const setEmailBody = ({commit}, payload) => {
    commit(types.EMAILBODY, payload)
}

export const setIsLoading = ({commit}, payload) => {
    commit(types.IS_LOADING, payload)
}

export const setPanelist = ({commit}, payload) => {
    commit(types.PANELIST, payload)
}
export const setStartTime = ({commit}, payload) => {
    commit(types.STARTTIME, payload)
}
export const setEndTime = ({commit}, payload) => {
    commit(types.ENDTIME, payload)
}
export const setForwardeddata = ({commit}, payload) => {
    commit(types.FORWARDEDDATA, payload)
}
export const setSubjectdata = ({commit}, payload) => {
    commit(types.SUBJECTDATA, payload)
}
export const setHtmlbody = ({commit}, payload) => {
    commit(types.HTMLBODY, payload)
}
export const setPanelistCore = ({commit}, payload) => {
    commit(types.PANELISTCORE, payload)
}
export const setPanelistScore = ({commit}, payload) => {
    commit(types.PANELISTSCORE, payload)
}
export const setEmailRead = ({commit}, payload) => {
    commit(types.EMAILREAD, payload)
}
export const setIndexName = ({commit}, payload) => {
    commit(types.INDEXNAME, payload)
}
export const setDeleted = ({commit}, payload) => {
    commit(types.DELETED, payload)
}